import { useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useCheckoutContext } from 'contexts/CheckoutContextProvider';

import { PAYMENT_VIEW_ROUTE } from '../../constants';

export const CheckoutPageProtectedRoute = ({
  baseRoute,
  children,
  isAfterPaymentStep,
}) => {
  const {
    selectedPlan = {},
    setUpIntentData = {},
    stripeDetails = {},
    stripeSetUpIntent = {},
  } = useCheckoutContext() || {};
  const { search = '' } = useLocation();
  const navigate = useNavigate();

  const hasSelectedPlan = useMemo(
    () => !!selectedPlan?.displayName,
    [selectedPlan]
  );
  const hasPaymentDetails = useMemo(
    () =>
      !!setUpIntentData?.createSetupIntent &&
      !!stripeSetUpIntent?.payment_method &&
      !!stripeDetails?.stripePaymentMethodId,
    [setUpIntentData, stripeSetUpIntent, stripeDetails]
  );

  const displayPath = useMemo(
    () =>
      !!isAfterPaymentStep
        ? hasSelectedPlan && hasPaymentDetails
        : hasSelectedPlan,
    [hasPaymentDetails, hasSelectedPlan, isAfterPaymentStep]
  );

  useEffect(() => {
    // logic for handling redirection
    // <Navigate /> gave infinite loop

    if (!displayPath) {
      if (hasSelectedPlan && !hasPaymentDetails) {
        return navigate(`${baseRoute}/${PAYMENT_VIEW_ROUTE}${search}`);
      } else {
        return navigate(baseRoute + search);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [displayPath, hasPaymentDetails, hasSelectedPlan]);

  return displayPath ? <>{children}</> : null;
};
